import { Kind } from "graphql";
export function getFragmentArgDefinitions(fragment) {
    var _fragment_directives;
    return (_fragment_directives = fragment.directives) === null || _fragment_directives === void 0 ? void 0 : _fragment_directives.find((d)=>d.name.value === 'argumentDefinitions');
}
// example:
// accountInput: {type: "OpenapiGetV1AccountInput"}
// returns:
// {argumentName: "accountInput", typeValue: "OpenapiGetV1AccountInput"}
export function getMetadatafromArgDefinition(arg, fragmentName) {
    if (arg.value.kind !== Kind.OBJECT) {
        throw new Error(`Unknown shape of argument definition on fragment ${fragmentName}`);
    }
    const argumentName = arg.name.value;
    const typeNode = arg.value.fields.find((f)=>f.name.value === 'type');
    if (!typeNode) {
        throw new Error(`Type for ${argumentName} needs to be defined on fragment ${fragmentName}`);
    }
    // So far we can only handle strings.
    if (typeNode.value.kind !== Kind.STRING) {
        throw new Error(`Unknown kind of type defined on argument definition on fragment ${fragmentName}. Expected StringValue, got ${typeNode.value.kind}`);
    }
    const typeValue = typeNode.value.value;
    return {
        argumentName,
        typeValue
    };
}

//# sourceMappingURL=argumentDefinitions.js.map